(() => {
	function init() {
		const $cartToggle = $('#cart-toggle');
		const $notification = $('#notification');
		const $content = $('#notification-content');
		const $close = $('#notification-close');

		if (!$notification.length || !$close.length) return;

		$close.on('click', async () => {
			await gsap
				.timeline()
				.to($content, {
					duration: 0.3,
					opacity: 0
				})
				.addLabel('mid')
				.to(
					$notification,
					{
						duration: 0.3,
						height: 0
					},
					'mid'
				)
				.to(
					$cartToggle,
					{
						duration: 0.3,
						top: 20
					},
					'mid'
				);

			$notification.remove();
			$cartToggle.removeClass('-offset');
			$cartToggle.attr('style', '');
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});
})();
